module.exports = __webpack_public_path__ + "img/bn.e1882e0.svg";